$('.menu-open').on('click', function(){
   $(this).toggleClass('close');
   $('.racing-menu > h2').removeClass('r-menu');
 $('.menu-middle').removeClass('r-current');
    $(this).next().toggleClass('current');
});


$('.racing-menu > h2').on('click', function(){
   $(this).toggleClass('r-menu');
  $('.menu-open').removeClass('close');
 $('ul.menu-tp').removeClass('current');
    $(this).next().toggleClass('r-current');
});
jQuery( window ).on( "load", function() {
jQuery( document ).ready(function() {
jQuery('.grid-image').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
  arrows: false,
    infinite: true,
    cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});
  });


jQuery( window ).on( "load", function() {
jQuery( document ).ready(function() {
jQuery('.product-single__thumbnails').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
  arrows: true,
  prevArrow:'<div class="p-arr p-left"><svg xmlns="http://www.w3.org/2000/svg" width="21.005" height="36.982" viewBox="0 0 21.005 36.982"><defs><style>.a{fill:#f7eff1;fill-rule:evenodd;}</style></defs><path class="a" d="M714.651,1194.53a1.569,1.569,0,0,1-2.184,0,1.5,1.5,0,0,1,0-2.15L728.9,1176.2l-16.428-15.62a1.492,1.492,0,0,1,0-2.14,1.55,1.55,0,0,1,2.184,0l18.362,17.76Z" transform="translate(733.018 1194.972) rotate(180)"></path></svg></div>',
    nextArrow:'<div class="p-arr p-right"><svg xmlns="http://www.w3.org/2000/svg" width="21.005" height="36.982" viewBox="0 0 21.005 36.982"><defs><style>.a{fill:#f7eff1;fill-rule:evenodd;}</style></defs><path class="a" d="M714.651,1194.53a1.569,1.569,0,0,1-2.184,0,1.5,1.5,0,0,1,0-2.15L728.9,1176.2l-16.428-15.62a1.492,1.492,0,0,1,0-2.14,1.55,1.55,0,0,1,2.184,0l18.362,17.76Z" transform="translate(-712.013 -1157.99)"></path></svg></div>',
    infinite: true,
    cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});
  });



  jQuery( window ).on( "load", function() {
jQuery( document ).ready(function() {
jQuery('.slider-p').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  arrows: false,
    infinite: true,
    cssEase: 'linear',
   adaptiveHeight: true
});
});
});
$('#CollectionSection header.section-header .rte.col').each(function() {
    var $pTag = $(this).find('p');
    if($pTag.text().length > 230){
        var shortText = $pTag.text();
        shortText = shortText.substring(0, 230);
        $pTag.addClass('fullArticle').hide();
        $pTag.append('<br><a class="read-less-link">Less</a>');
        $(this).append('<p class="preview">'+shortText+'</p><div class="curtain-shadow"></div><a class="read-more-link">Read more</a>');
    }
});

$(document).on('click', '.read-more-link', function () {
    $(this).hide().parent().find('.preview').hide().prev().show();
});

$(document).on('click', '.read-less-link', function () {
    $(this).parent().hide().next().show();
    $(this).parents('#CollectionSection header.section-header .rte.col').find('.read-more-link').show();
});
/*
setInterval(function(){
	$("input[name*='Leather']").each(function(){
        let price = $(this).attr("data-value-price");

        if(price != "" && price != 0){
            $(this).attr("data-value-recalc-price", 0);
            $(this).attr("data-value-price", 0);
            $(this).next().children(".value-price").first().children(".money").html("CHF <span>"+price+"</span> <strong>0</strong>");
        }

        
    })
    let price = $("input[value=Paramount]").attr("data-value-price");
    if(price != "" && price != 0) {
        $("input[value=Paramount]").attr("data-value-recalc-price", 0)
        $("input[value=Paramount]").attr("data-value-price", 0)
        $("input[value=Paramount]").next().children(".value-price").first().children(".money").html("CHF <span>"+price+"</span> <strong>0</strong>");
    }
}, 10);
*/
